import { create } from 'zustand';

interface ICommonState {
  loadingTable: boolean;
  setLoadingTable: (loadingTable: boolean) => void;
  loadingSummary: boolean;
  setLoadingSummary: (loadingSummary: boolean) => void;
  loadingModal: boolean;
  setLoadingModal: (loadingModal: boolean) => void;
}

const useCommonStore = create<ICommonState>((set) => ({
  loadingTable: false,
  setLoadingTable: (loadingTable) => set({ loadingTable }),
  loadingSummary: false,
  setLoadingSummary: (loadingSummary) => set({ loadingSummary }),
  loadingModal: false,
  setLoadingModal: (loadingModal) => set({ loadingModal }),
}));

export default useCommonStore;
